import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2104ca49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-panel" }
const _hoisted_2 = { class: "header_panel" }
const _hoisted_3 = {
  key: 0,
  class: "no-results-message"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionDivisor = _resolveComponent("SectionDivisor")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SectionDivisor, {
        title: "Perguntas frequentes",
        colorLabel: "var(--primary-color)",
        "color-background": "#fafafa",
        "color-line": "var(--primary-color)",
        class: "divisor-faq"
      })
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "input-faq_landingpage",
      id: "title",
      title: "Título",
      placeholder: "Qual sua dúvida?",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, _ctx.searchQuery]
    ]),
    (_ctx.filteredInformations.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Nenhuma dúvida encontrada. "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredInformations, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['info-box', { 'info-box--active': _ctx.openItems[index] }])
      }, [
        _createElementVNode("button", {
          class: "header_dropdown",
          onClick: ($event: any) => (_ctx.toggleItem(index))
        }, [
          _createElementVNode("p", null, _toDisplayString(item.question), 1),
          _createElementVNode("span", {
            class: _normalizeClass(['icon__arrow', { 'icon__arrow--active': _ctx.openItems[index] }])
          }, null, 2)
        ], 8, _hoisted_4),
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "content",
              onClick: ($event: any) => (_ctx.toggleItem(index))
            }, [
              _createVNode(_component_TUIViewer, {
                modelValue: item.response
              }, null, 8, ["modelValue"])
            ], 8, _hoisted_5), [
              [_vShow, _ctx.openItems[index]]
            ])
          ]),
          _: 2
        }, 1024)
      ], 2))
    }), 128))
  ]))
}